import {classNames} from '@cohort/shared-frontend/utils/classNames';
import type {BaseButtonProps} from '@cohort/wallet/components/button/BaseButton';
import {BaseButton} from '@cohort/wallet/components/button/BaseButton';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';

type PrimaryBtnProps = BaseButtonProps;

const PrimaryButton: React.FC<PrimaryBtnProps> = ({className, ...props}): JSX.Element => {
  const {accentColor, hasDarkAccent} = useThemeContext();

  return (
    <BaseButton
      style={{backgroundColor: accentColor}}
      className={classNames(className, hasDarkAccent ? 'text-white' : 'text-black')}
      {...props}
    />
  );
};

export default PrimaryButton;
